class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.cartToastTimer = null;

    if (this.notification) {
      this.notification.addEventListener(
        'keyup',
        (evt) => evt.code === 'Escape' && this.close()
      );

      this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
        closeButton.addEventListener('click', this.close.bind(this))
      );
    }

    this.createCartToast();
  }


  /* =========================================================
     ORIGINAL OPEN-FUNKTION BLEIBT VORHANDEN
     WIRD BEIM HINZUFÜGEN ABER NICHT MEHR AUFGERUFEN
     ========================================================= */

  open() {
    if (!this.notification) return;

    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();

        if (typeof trapFocus === 'function') {
          trapFocus(this.notification);
        }
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }


  /* =========================================================
     ORIGINAL CLOSE-FUNKTION
     ========================================================= */

  close() {
    if (this.notification) {
      this.notification.classList.remove('active');
    }

    document.body.removeEventListener('click', this.onBodyClick);

    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(this.activeElement);
    }
  }


  /* =========================================================
     WARENKORB AKTUALISIEREN
     ABER RECHTES FENSTER NICHT ÖFFNEN
     ========================================================= */

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;

    this.getSectionsToRender().forEach((section) => {
      const target = document.getElementById(section.id);

      if (
        target &&
        parsedState.sections &&
        parsedState.sections[section.id]
      ) {
        target.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector
        );
      }
    });

    if (this.header) {
      this.header.reveal();
    }

    /*
      WICHTIG:
      this.open(); wurde hier absichtlich entfernt.

      Dadurch öffnet sich der rechte Warenkorb NICHT mehr.
    */

    this.showCartToast();
  }


  /* =========================================================
     SHOPIFY-SECTIONS
     BLEIBEN ERHALTEN
     ========================================================= */

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }


  /* =========================================================
     SHOPIFY HTML AUSLESEN
     ========================================================= */

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const parsedDocument = new DOMParser().parseFromString(
      html,
      'text/html'
    );

    const element = parsedDocument.querySelector(selector);

    return element ? element.innerHTML : '';
  }


  /* =========================================================
     ORIGINAL CLICK-OUTSIDE
     ========================================================= */

  handleBodyClick(evt) {
    const target = evt.target;

    if (
      this.notification &&
      target !== this.notification &&
      !target.closest('cart-notification')
    ) {
      const disclosure = target.closest(
        'details-disclosure, header-menu'
      );

      this.activeElement = disclosure
        ? disclosure.querySelector('summary')
        : null;

      this.close();
    }
  }


  /* =========================================================
     ORIGINAL ACTIVE ELEMENT
     ========================================================= */

  setActiveElement(element) {
    this.activeElement = element;
  }


  /* =========================================================
     GRÜNE ERFOLGSMELDUNG ERSTELLEN
     ========================================================= */

  createCartToast() {
    const existingToast = document.getElementById(
      'hs-cart-success-toast'
    );

    if (existingToast) {
      this.cartToast = existingToast;
      return;
    }

    const toast = document.createElement('div');

    toast.id = 'hs-cart-success-toast';

    toast.innerHTML = `
      <div class="hs-cart-toast-inner">

        <div class="hs-cart-toast-icon">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <circle
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              stroke-width="2"
            ></circle>

            <path
              d="M7.5 12.3L10.4 15.2L16.8 8.8"
              stroke="currentColor"
              stroke-width="2.2"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
          </svg>
        </div>

        <div class="hs-cart-toast-message">
          Erfolgreich zum
          <a href="/cart">Warenkorb</a>
          hinzugefügt
        </div>

        <button
          type="button"
          class="hs-cart-toast-close"
          aria-label="Meldung schließen"
        >
          ×
        </button>

      </div>
    `;

    document.body.appendChild(toast);

    this.cartToast = toast;

    const closeButton = toast.querySelector(
      '.hs-cart-toast-close'
    );

    if (closeButton) {
      closeButton.addEventListener('click', () => {
        this.hideCartToast();
      });
    }

    this.createCartToastStyles();
  }


  /* =========================================================
     CSS DER GRÜNEN MELDUNG
     ========================================================= */

  createCartToastStyles() {
    if (
      document.getElementById('hs-cart-success-toast-styles')
    ) {
      return;
    }

    const style = document.createElement('style');

    style.id = 'hs-cart-success-toast-styles';

    style.textContent = `

      #hs-cart-success-toast {
        position: fixed !important;

        top: 20px !important;
        left: 50% !important;

        width: auto !important;
        max-width: calc(100% - 30px) !important;

        margin: 0 !important;
        padding: 0 !important;

        z-index: 2147483647 !important;

        opacity: 0 !important;
        visibility: hidden !important;

        transform: translate(-50%, -15px) !important;

        pointer-events: none !important;

        transition:
          opacity 0.25s ease,
          transform 0.25s ease,
          visibility 0.25s ease !important;
      }


      #hs-cart-success-toast.hs-visible {
        opacity: 1 !important;
        visibility: visible !important;

        transform: translate(-50%, 0) !important;

        pointer-events: auto !important;
      }


      #hs-cart-success-toast .hs-cart-toast-inner {
        display: flex !important;

        align-items: center !important;
        justify-content: center !important;

        gap: 10px !important;

        min-height: 52px !important;

        padding: 12px 16px !important;

        background: #ecfdf3 !important;

        border: 1px solid #15945a !important;

        border-radius: 12px !important;

        box-shadow:
          0 10px 30px rgba(0, 0, 0, 0.16) !important;

        color: #087443 !important;

        font-family: inherit !important;
      }


      #hs-cart-success-toast .hs-cart-toast-icon {
        display: flex !important;

        align-items: center !important;
        justify-content: center !important;

        flex: 0 0 auto !important;

        color: #087443 !important;
      }


      #hs-cart-success-toast .hs-cart-toast-message {
        margin: 0 !important;
        padding: 0 !important;

        font-size: 15px !important;
        line-height: 1.4 !important;

        font-weight: 600 !important;

        color: #087443 !important;

        white-space: nowrap !important;
      }


      #hs-cart-success-toast .hs-cart-toast-message a {
        color: #087443 !important;

        font-weight: 800 !important;

        text-decoration: underline !important;
        text-underline-offset: 2px !important;

        cursor: pointer !important;

        opacity: 1 !important;

        transform: none !important;
      }


      #hs-cart-success-toast .hs-cart-toast-message a:hover,
      #hs-cart-success-toast .hs-cart-toast-message a:focus {
        color: #087443 !important;

        opacity: 1 !important;

        transform: none !important;

        text-decoration: underline !important;
      }


      #hs-cart-success-toast .hs-cart-toast-close {
        display: flex !important;

        align-items: center !important;
        justify-content: center !important;

        width: 26px !important;
        height: 26px !important;

        min-width: 26px !important;

        margin: 0 !important;
        padding: 0 !important;

        border: 0 !important;

        background: transparent !important;

        color: #087443 !important;

        font-family: Arial, sans-serif !important;

        font-size: 23px !important;
        font-weight: 400 !important;

        line-height: 1 !important;

        cursor: pointer !important;

        box-shadow: none !important;
      }


      @media screen and (max-width: 749px) {

        #hs-cart-success-toast {
          top: 12px !important;

          width: calc(100% - 24px) !important;
          max-width: 500px !important;
        }


        #hs-cart-success-toast .hs-cart-toast-inner {
          justify-content: flex-start !important;

          padding: 12px 13px !important;

          gap: 8px !important;
        }


        #hs-cart-success-toast .hs-cart-toast-message {
          flex: 1 1 auto !important;

          font-size: 14px !important;

          white-space: normal !important;
        }

      }

    `;

    document.head.appendChild(style);
  }


  /* =========================================================
     GRÜNE MELDUNG ANZEIGEN
     ========================================================= */

  showCartToast() {
    if (!this.cartToast) {
      this.createCartToast();
    }

    if (!this.cartToast) {
      return;
    }

    if (this.cartToastTimer) {
      clearTimeout(this.cartToastTimer);
    }

    /*
      Kurz entfernen und neu hinzufügen.
      Dadurch funktioniert die Animation auch,
      wenn schnell hintereinander Produkte hinzugefügt werden.
    */

    this.cartToast.classList.remove('hs-visible');

    void this.cartToast.offsetWidth;

    this.cartToast.classList.add('hs-visible');

    this.cartToastTimer = setTimeout(() => {
      this.hideCartToast();
    }, 4000);
  }


  /* =========================================================
     GRÜNE MELDUNG AUSBLENDEN
     ========================================================= */

  hideCartToast() {
    if (!this.cartToast) {
      return;
    }

    this.cartToast.classList.remove('hs-visible');

    if (this.cartToastTimer) {
      clearTimeout(this.cartToastTimer);

      this.cartToastTimer = null;
    }
  }
}


customElements.define(
  'cart-notification',
  CartNotification
);